var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"successNo"},[_c('em',{staticClass:"icon"}),_vm._v(" "),_c('p',[_vm._v("提交成功")]),_vm._v(" "),_c('div',{staticClass:"btn_return"},[_c('a',{attrs:{"href":_vm.infoUrl}},[_vm._v("继续浏览信息")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15da3366","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/SuccessNoLogin/SuccessNoLogin.vue
// module id = null
// module chunks = 